import { AppEvent } from 'types/appEvent';
import { PartnerClientManager } from 'types/partnerClientManagerTypes';
import { createPartnerClientManager } from 'utils/partnerClientManagerUtils';
import { createReducer } from 'utils/reducer/reducerUtils';

export const reduceToNextPartnerClientManager = createReducer<
  PartnerClientManager,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'PartnerAccountManager__ManageClient':
    case 'PartnerClientsPage__ManageClient':
      return {
        ...prev,
        opened: true,
        clientId: event.clientId,
        organizationName: event.organizationName,
        clientInvalidated: true,
        notesTextInvalidated: true,
        monthReportsInvalidated: true,
      };
    case 'PartnerClientManager__Closed':
      return {
        ...createPartnerClientManager(),
      };
    case 'PartnerClientManager__MonthReportsRecieved':
      return {
        ...prev,
        monthReports: event.monthReports,
        monthReportsInvalidated: false,
      };
    case 'PartnerClientManager__ClientRecieved':
      return {
        ...prev,
        client: event.client,
        clientInvalidated: false,
      };
    case 'PartnerClientManager__NotesTextRecieved':
      return {
        ...prev,
        notesText: event.value,
        notesTextInvalidated: false,
      };
    case 'PartnerClientManager__NotesTextChanged':
      return {
        ...prev,
        notesText: event.nextValue,
      };
    default:
      return prev;
  }
});
